import type { DriveStep } from "driver.js";

export const DASHBOARD_TOUR_STEPS: DriveStep[] = [
  {
    element: "#dashboard-arrivals",
    popover: {
      title: "Anreisen heute",
      description:
        "Hier sehen Sie Gäste mit geplanter Anreise, die noch nicht eingecheckt sind. Per Klick auf eine Zeile öffnen Sie die Buchungsdetails; der Check-in startet direkt aus der Liste.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: "#dashboard-departures",
    popover: {
      title: "Abreisen heute",
      description:
        "Eingecheckte Gäste mit Abreise heute. Offene Rechnungen und Schlüsselrückgabe werden beim Check-out berücksichtigt.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: "#dashboard-inquiries",
    popover: {
      title: "Offene Anfragen",
      description:
        "Neue Online-Anfragen und Reservierungswünsche landen hier. Bestätigen oder ablehnen Sie Anfragen und senden Sie optional eine E-Mail-Antwort.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: "#dashboard-site-plan",
    popover: {
      title: "Platzplan (Mini)",
      description:
        "Kompakte Übersicht der aktuellen Belegung. Ein Klick auf einen Platz öffnet Details und Planungsoptionen.",
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="dashboard-toolbar"]',
    popover: {
      title: "Schnellaktionen",
      description:
        "Vom Dashboard aus starten Sie Schnellbuchungen mit den nötigsten Angaben – den Rest fragt eine E-Mail ab. Außerdem öffnen Sie die Kasse, die Gästeliste oder den Belegungsplaner, ohne die Seite zu wechseln.",
      side: "bottom",
      align: "end",
    },
  },
];
